// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".automation[data-v-aec5e4d4]{padding:40px}.automation .top[data-v-aec5e4d4]{margin:0 0 40px}.automation .layout[data-v-aec5e4d4]{display:grid;grid-template-columns:215px auto;grid-gap:60px}", ""]);
// Exports
module.exports = exports;
